var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 989.801,
    height: 37.888,
    viewBox: "0 0 989.801 37.888",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2991",
    "data-name": "Groupe 2991",
    transform: "translate(-233.359 -2847.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1963",
    "data-name": "Groupe 1963",
    transform: "translate(0 16.629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_502",
    "data-name": "Trac\\xE9 502",
    transform: "translate(1162.761 2831.243)",
    fill: "#00a3da"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 54.63021087646484 36.25879287719727 L 0.9999997615814209 36.25879287719727 L 0.9999997615814209 1.000004529953003 L 54.6342658996582 1.000004529953003 L 59.36382293701172 18.44193077087402 L 54.63021087646484 36.25879287719727 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2 1.999996185302734 L 2 35.25878524780273 L 53.86120223999023 35.25878524780273 L 58.32843399047852 18.44456481933594 L 53.86931991577148 1.999996185302734 L 2 1.999996185302734 M 0 -3.814697265625e-06 L 55.39921951293945 -3.814697265625e-06 L 60.39921951293945 18.43927383422852 L 55.39921951293945 37.25878524780273 L 0 37.25878524780273 L 0 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_511",
    "data-name": "Trac\\xE9 511",
    d: "M7.34,21,12.38,6.1H16.5L21.54,21H18.16l-1-3.04H11.7L10.7,21Zm5.22-5.74H16.3L14.02,8.22h.84ZM27.3,21V17.24H23.54v-2.5H27.3V11h2.5v3.74h3.74v2.5H29.8V21Zm13.56,0V17.24H37.1v-2.5h3.76V11h2.5v3.74H47.1v2.5H43.36V21Z",
    transform: "translate(1167.16 2837.872)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1964",
    "data-name": "Groupe 1964",
    transform: "translate(0 16.629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_501",
    "data-name": "Trac\\xE9 501",
    transform: "translate(1110.317 2831.243)",
    fill: "#00823f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 53.56153869628906 36.25879287719727 L 1.000000715255737 36.25879287719727 L 1.000000715255737 1.000004529953003 L 53.56118392944336 1.000004529953003 L 58.29296875 18.64542198181152 L 53.56153869628906 36.25879287719727 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2 1.999996185302734 L 2 35.25878524780273 L 52.79471588134766 35.25878524780273 L 57.2575798034668 18.64519119262695 L 52.79401779174805 1.999996185302734 L 2 1.999996185302734 M 0 -3.814697265625e-06 L 54.32836151123047 -3.814697265625e-06 L 59.32836151123047 18.64563369750977 L 54.32836151123047 37.25878524780273 L 0 37.25878524780273 L 0 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_510",
    "data-name": "Trac\\xE9 510",
    d: "M2.437,21,7.477,6.1H11.6L16.637,21h-3.38l-1-3.04H6.8L5.8,21Zm5.22-5.74H11.4L9.117,8.22h.84ZM23.763,21V17.24H20v-2.5h3.76V11h2.5v3.74H30v2.5h-3.74V21Z",
    transform: "translate(1124.478 2837.872)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1965",
    "data-name": "Groupe 1965",
    transform: "translate(0 16.629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_500",
    "data-name": "Trac\\xE9 500",
    transform: "translate(1048.21 2831.243)",
    fill: "#00a652"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 63.23000717163086 36.25879287719727 L 1.000005722045898 36.25879287719727 L 1.000005722045898 1.000004529953003 L 63.22216415405273 1.000004529953003 L 67.95761871337891 18.99163818359375 L 63.23000717163086 36.25879287719727 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.999992370605469 1.999996185302734 L 1.999992370605469 35.25878143310547 L 62.46698760986328 35.25878143310547 L 66.92220306396484 18.98652267456055 L 62.45130157470703 1.999996185302734 L 1.999992370605469 1.999996185302734 M -7.62939453125e-06 -3.814697265625e-06 L 63.99300384521484 -3.814697265625e-06 L 68.99300384521484 18.99674987792969 L 63.99300384521484 37.25878524780273 L -7.62939453125e-06 37.25878524780273 L -7.62939453125e-06 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_509",
    "data-name": "Trac\\xE9 509",
    d: "M1.9,21,6.94,6.1h4.12L16.1,21H12.72l-1-3.04H6.26L5.26,21Zm5.22-5.74h3.74L8.58,8.22h.84Z",
    transform: "translate(1068.415 2837.372)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1966",
    "data-name": "Groupe 1966",
    transform: "translate(0 16.629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_499",
    "data-name": "Trac\\xE9 499",
    transform: "translate(972.841 2831.243)",
    fill: "#66b654"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.60318756103516 36.25879287719727 L 1.000007152557373 36.25879287719727 L 1.000007152557373 1.000006318092346 L 79.60089111328125 1.000006318092346 L 84.33364105224609 18.73537826538086 L 79.60318756103516 36.25879287719727 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2 1.999996185302734 L 2 35.25878143310547 L 78.83733367919922 35.25878143310547 L 83.29824066162109 18.73386192321777 L 78.83274841308594 1.999996185302734 L 2 1.999996185302734 M 0 -3.814697265625e-06 L 80.36902618408203 -3.814697265625e-06 L 85.36902618408203 18.73686981201172 L 80.36902618408203 37.25878143310547 L 0 37.25878143310547 L 0 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_508",
    "data-name": "Trac\\xE9 508",
    d: "M2.92,21V6.1h6.3a6.134,6.134,0,0,1,2.64.52,3.782,3.782,0,0,1,1.68,1.49,4.5,4.5,0,0,1,.58,2.35,3.551,3.551,0,0,1-.54,1.87,4.073,4.073,0,0,1-1.78,1.49V12.3a5.233,5.233,0,0,1,1.82,1.1,3.455,3.455,0,0,1,.88,1.39,5.12,5.12,0,0,1,.24,1.57,4.211,4.211,0,0,1-1.46,3.42A6.149,6.149,0,0,1,9.22,21Zm3.1-2.7H9.58a2.07,2.07,0,0,0,1.5-.54,1.858,1.858,0,0,0,.56-1.4,1.883,1.883,0,0,0-.56-1.42,2.07,2.07,0,0,0-1.5-.54H6.02Zm0-6.6H9.44a1.6,1.6,0,0,0,1.15-.41,1.436,1.436,0,0,0,.43-1.09,1.436,1.436,0,0,0-.43-1.09A1.6,1.6,0,0,0,9.44,8.7H6.02Z",
    transform: "translate(1004.785 2836.322)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1967",
    "data-name": "Groupe 1967",
    transform: "translate(0 16.629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_498",
    "data-name": "Trac\\xE9 498",
    transform: "translate(906.737 2831.243)",
    fill: "#c0d445"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 84.70996856689453 36.25879287719727 L 1.000003099441528 36.25879287719727 L 1.000003099441528 1.000007033348083 L 84.71910095214844 1.000007033348083 L 89.36036682128906 18.20243453979492 L 84.70996856689453 36.25879287719727 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2 1.999996185302734 L 2 35.25879287719727 L 83.93487548828125 35.25879287719727 L 88.32621002197266 18.2083740234375 L 83.95314025878906 1.999996185302734 L 2 1.999996185302734 M 0 -3.814697265625e-06 L 85.48505401611328 -3.814697265625e-06 L 90.39453125 18.1965274810791 L 85.48505401611328 37.25879287719727 L 0 37.25879287719727 L 0 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_507",
    "data-name": "Trac\\xE9 507",
    d: "M10.68,21.24a7.539,7.539,0,0,1-2.97-.58,7.294,7.294,0,0,1-2.39-1.62A7.465,7.465,0,0,1,3.73,16.6a8.039,8.039,0,0,1-.57-3.06,8.243,8.243,0,0,1,.56-3.07A7.167,7.167,0,0,1,7.69,6.43a7.707,7.707,0,0,1,2.99-.57,7.472,7.472,0,0,1,2.91.54,6.729,6.729,0,0,1,2.19,1.44,5.231,5.231,0,0,1,1.28,2l-2.74,1.32a3.729,3.729,0,0,0-3.64-2.5,4.312,4.312,0,0,0-2.32.62,4.184,4.184,0,0,0-1.55,1.71,5.592,5.592,0,0,0-.55,2.55,5.655,5.655,0,0,0,.55,2.56,4.17,4.17,0,0,0,1.55,1.72,4.312,4.312,0,0,0,2.32.62,3.729,3.729,0,0,0,3.64-2.5l2.74,1.32a5.231,5.231,0,0,1-1.28,2,6.729,6.729,0,0,1-2.19,1.44A7.472,7.472,0,0,1,10.68,21.24Z",
    transform: "translate(924.752 2837.617)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1968",
    "data-name": "Groupe 1968",
    transform: "translate(0 16.629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_496",
    "data-name": "Trac\\xE9 496",
    transform: "translate(802.818 2831.243)",
    fill: "#dfe143"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 107.5608444213867 36.25879287719727 L 1.000009059906006 36.25879287719727 L 1.000009059906006 0.9999945163726807 L 107.5649871826172 0.9999945163726807 L 112.2945022583008 18.43791389465332 L 107.5608444213867 36.25879287719727 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2 1.999996185302734 L 2 35.25879287719727 L 106.7917938232422 35.25879287719727 L 111.2591094970703 18.44062805175781 L 106.8000793457031 1.999996185302734 L 2 1.999996185302734 M 0 -3.814697265625e-06 L 108.3298950195312 -3.814697265625e-06 L 113.3298950195312 18.43521118164062 L 108.3298950195312 37.25879287719727 L 0 37.25879287719727 L 0 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_506",
    "data-name": "Trac\\xE9 506",
    d: "M1.93,21V6.1H6.79a8.721,8.721,0,0,1,4.2.96A6.929,6.929,0,0,1,13.75,9.7a7.479,7.479,0,0,1,.98,3.84,7.533,7.533,0,0,1-.98,3.85,6.908,6.908,0,0,1-2.76,2.65,8.721,8.721,0,0,1-4.2.96Zm3.1-2.7H6.87a5.1,5.1,0,0,0,2.52-.59,4.162,4.162,0,0,0,1.65-1.66,5.117,5.117,0,0,0,.59-2.51,5.1,5.1,0,0,0-.59-2.52A4.112,4.112,0,0,0,9.39,9.38,5.174,5.174,0,0,0,6.87,8.8H5.03Z",
    transform: "translate(819.754 2837.872)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1969",
    "data-name": "Groupe 1969",
    transform: "translate(0 16.629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_495",
    "data-name": "Trac\\xE9 495",
    transform: "translate(661.826 2831.243)",
    fill: "#f7c030"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 140.7924957275391 36.25879287719727 L 1.00000786781311 36.25879287719727 L 1.00000786781311 0.9999945163726807 L 140.8035736083984 0.9999945163726807 L 145.5294952392578 18.1176815032959 L 140.7924957275391 36.25879287719727 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.999984741210938 1.999996185302734 L 1.999984741210938 35.25879287719727 L 140.0200653076172 35.25879287719727 L 144.4940490722656 18.12490844726562 L 140.0422210693359 1.999996185302734 L 1.999984741210938 1.999996185302734 M -1.52587890625e-05 -3.814697265625e-06 L 141.5648803710938 -3.814697265625e-06 L 146.5648803710938 18.11045455932617 L 141.5648803710938 37.25879287719727 L -1.52587890625e-05 37.25879287719727 L -1.52587890625e-05 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_505",
    "data-name": "Trac\\xE9 505",
    d: "M2.93,21V6.1H12.95V8.8H6.03v3.38h6.52v2.7H6.03V18.3h6.92V21Z",
    transform: "translate(679.474 2837.872)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1970",
    "data-name": "Groupe 1970",
    transform: "translate(0 16.629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_494",
    "data-name": "Trac\\xE9 494",
    transform: "translate(493.393 2831.743)",
    fill: "#ec9441"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 169.6353454589844 36.25878143310547 L 1.000009775161743 36.25878143310547 L 1.000009775161743 1.000008225440979 L 169.6514739990234 1.000008225440979 L 174.3746948242188 17.88542938232422 L 169.6353454589844 36.25878143310547 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2 1.999988555908203 L 2 35.2588005065918 L 168.8605194091797 35.2588005065918 L 173.3392028808594 17.89593315124512 L 168.8927764892578 1.999988555908203 L 2 1.999988555908203 M 0 -1.1444091796875e-05 L 170.4100952148438 -1.1444091796875e-05 L 175.4101104736328 17.87491798400879 L 170.4100952148438 37.2588005065918 L 0 37.2588005065918 L 0 -1.1444091796875e-05 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_504",
    "data-name": "Trac\\xE9 504",
    d: "M3.95,21V6.1h10.2V8.8H7.05v3.78h6.1v2.7H7.05V21Z",
    transform: "translate(510.486 2838.372)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1971",
    "data-name": "Groupe 1971",
    transform: "translate(0 16.629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_497",
    "data-name": "Trac\\xE9 497",
    transform: "translate(233.359 2831.872)",
    fill: "#d8232a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 265.1048278808594 36.2587890625 L 1.000018000602722 36.2587890625 L 1.000018000602722 1.000001668930054 L 265.1011352539062 1.000001668930054 L 269.8345642089844 18.80073928833008 L 265.1048278808594 36.2587890625 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.999969482421875 2 L 1.999969482421875 35.2587890625 L 264.3396911621094 35.2587890625 L 268.7991638183594 18.79831504821777 L 264.332275390625 2 L 1.999969482421875 2 M -3.0517578125e-05 0 L 265.8699340820312 0 L 270.8699340820312 18.80314445495605 L 265.8699340820312 37.2587890625 L -3.0517578125e-05 37.2587890625 L -3.0517578125e-05 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_503",
    "data-name": "Trac\\xE9 503",
    d: "M10.94,21.24a7.612,7.612,0,0,1-2.98-.58A7.446,7.446,0,0,1,3.92,16.6a7.917,7.917,0,0,1-.58-3.06,8.243,8.243,0,0,1,.56-3.07A7.167,7.167,0,0,1,7.87,6.43a7.707,7.707,0,0,1,2.99-.57,7.472,7.472,0,0,1,2.91.54,6.729,6.729,0,0,1,2.19,1.44,5.231,5.231,0,0,1,1.28,2L14.5,11.16a3.729,3.729,0,0,0-3.64-2.5,4.312,4.312,0,0,0-2.32.62,4.184,4.184,0,0,0-1.55,1.71,5.592,5.592,0,0,0-.55,2.55,5.411,5.411,0,0,0,.58,2.56,4.266,4.266,0,0,0,3.92,2.34,4.706,4.706,0,0,0,1.91-.39,3.512,3.512,0,0,0,1.44-1.13,2.9,2.9,0,0,0,.55-1.78V13.9l1.42,1.2h-5.4V12.5h7.08v1.58a7.751,7.751,0,0,1-.6,3.17,6.4,6.4,0,0,1-1.61,2.24,6.673,6.673,0,0,1-2.26,1.32A7.73,7.73,0,0,1,10.94,21.24Z",
    transform: "translate(248.579 2837.872)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeb);
export default __webpack_public_path__ + "static/media/PEB.ed4a15332514520aed4a9a4dc58000a1.svg";
export { ForwardRef as ReactComponent };